const globalState = {
  isLoading: false,
  listCompanyNotifications: null,
  listWorkerNotifications: null,
};

export default globalState;

